// import { useState, useRef, useEffect } from "react";
// import { IoClose, IoCopyOutline, IoDownloadOutline } from "react-icons/io5";
// import { IoDocumentTextOutline } from "react-icons/io5";



// export function KbSessionCell({ item }) {
//   // console.log(item, 'flat')
//   const [showModal, setShowModal] = useState(false);
//   const [openSession, setOpenSession] = useState(null);
//   const [openItems, setOpenItems] = useState({});
//   const [search, setSearch] = useState("");
//   const itemRefs = useRef([]);

//   const toggleSession = (sessionId) => {
//     setOpenSession((prev) => {
//       const next = prev === sessionId ? null : sessionId;

//       if (next && openItems[next] === undefined) {
//         setOpenItems((old) => ({
//           ...old,
//           [next]: 0,
//         }));
//       }

//       return next;
//     });
//   };
//   const toggleQuestion = (sessionKey, index) => {
//     setOpenItems((prev) => ({
//       ...prev,
//       [sessionKey]:
//         prev[sessionKey] === index ? null : index,
//     }));
//   };
//   useEffect(() => {
//     if (!showModal || !item?.length) return;

//     const firstSessionId = item[0]?.id || 0;

//     setOpenSession(firstSessionId);

//     setOpenItems({
//       [firstSessionId]: 0,
//     });
//   }, [showModal, item]);
//   // 👉 Flatten history into transcript rows
//   const filtered = item.flatMap((session) =>
//     (session.history || []).map((h) => ({
//       id: h.history_id,
//       question: h.question,
//       answer: h.clicked_option,
//       time: h.clicked_at,
//       intent: session.intent_name,
//       flow: session.flow_name,
//     }))
//   );

//   const escapeRegex = (str) =>
//     str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

//   const highlightText = (text, query) => {
//     if (!query) return text;

//     const regex = new RegExp(`(${escapeRegex(query)})`, "gi");

//     return String(text).split(regex).map((part, i) =>
//       part.toLowerCase() === query.toLowerCase() ? (
//         <span key={i} className="transcript-highlight">
//           {part}
//         </span>
//       ) : (
//         part
//       )
//     );
//   };

//   return (
//     <>
//       <IoDocumentTextOutline
//         onClick={() => setShowModal(true)}
//         style={{ fontSize: "20px", cursor: "pointer", color: "#0782D5" }}
//       />

//       {showModal && (
//         <div className="transcript-overlay" onClick={() => setShowModal(false)}>
//           <div className="kb-modal" onClick={(e) => e.stopPropagation()}>

//             {/* Header */}
//             <div className="kb-header">
//               <div className="kb-headerLeft">
//                 <span className="kb-title">KB Session</span>
//               </div>

//               <div className="kb-headerRight">
//                 <input
//                   type="text"
//                   placeholder="Search logs..."
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   className="transcript-searchInput"
//                 />

//                 <button
//                   className="transcript-closeBtn"
//                   onClick={() => {
//                     setShowModal(false);
//                     setSearch("");
//                   }}
//                 >
//                   <IoClose size={18} />
//                 </button>
//               </div>
//             </div>

//             {/* Body */}
//             <div className="kb-body">
//               {item
//                 .filter(session => session.history?.length > 0)
//                 .map((session, sessionIndex) => (
//                   <div key={session.id || sessionIndex} className="kb-card">

//                     {/* SESSION HEADER */}
//                     <div
//                       className="kb-cardHeader kb-sessionAccordion"
//                       onClick={() =>
//                         toggleSession(session.id || sessionIndex)
//                       }
//                     >
//                       <span className="kb-badge">
//                         {session.intent_name}
//                       </span>

//                       <div className="kb-meta">
//                         <span className="kb-flowName">
//                           {session.flow_name}
//                         </span>

//                         <span className="kb-dot">•</span>

//                         <span
//                           className={`kb-statusTag ${session.status?.toLowerCase() === "completed"
//                               ? "status-complete"
//                               : "status-pending"
//                             }`}
//                         >
//                           {session.status}
//                         </span>
//                       </div>

//                       <span className="kb-sessionArrow">
//                         {openSession ===
//                           (session.id || sessionIndex)
//                           ? "▼"
//                           : "▶"}
//                       </span>
//                     </div>

//                     {/* HISTORY LIST (Nested Step Threads) */}
//                     {openSession ===
//                       (session.id || sessionIndex) && (
//                         <div className="kb-content">
//                           {[...(session.history || [])]
//                             .reverse()
//                             .map((h, index) => {
//                               const sessionKey = session.id || sessionIndex;
//                               const isOpen = openItems[sessionKey] === index;

//                               return (
//                                 <div
//                                   key={h.history_id || index}
//                                   className={`kb-stepBlock ${isOpen ? "active" : ""}`}
//                                 >
//                                   {/* Accordion Header */}
//                                   <div
//                                     className="kb-questionHeader"
//                                     onClick={() =>
//                                       toggleQuestion(sessionKey, index)
//                                     }
//                                   >
//                                     <div className="kb-questionLeft">
//                                       <span className="kb-label-badge q-badge">
//                                         Q
//                                       </span>

//                                       <p className="kb-textQuestion">
//                                         {highlightText(h.question, search)}
//                                       </p>
//                                     </div>

//                                     <span className="kb-arrow">
//                                       {isOpen ? "−" : "+"}
//                                     </span>
//                                   </div>

//                                   {/* Accordion Body */}
//                                   {isOpen && (
//                                     <div className="kb-answerContainer">

//                                       {h.resolution_text && (
//                                         <div className="kb-resolutionBox">
//                                           <div className="kb-resolutionHeader">
//                                             <span className="kb-resolutionIcon">
//                                               🛠️
//                                             </span>

//                                             <span className="kb-resolutionText">
//                                               {highlightText(
//                                                 h.resolution_text,
//                                                 search
//                                               )}
//                                             </span>
//                                           </div>
//                                         </div>
//                                       )}

//                                       <div className="kb-answerRow">
//                                         <span className="kb-label-badge a-badge">
//                                           A
//                                         </span>

//                                         <p
//                                           className={`kb-textAnswer ${h.clicked_option?.toLowerCase() ===
//                                               "yes"
//                                               ? "ans-yes"
//                                               : h.clicked_option?.toLowerCase() ===
//                                                 "no"
//                                                 ? "ans-no"
//                                                 : ""
//                                             }`}
//                                         >
//                                           {highlightText(
//                                             h.clicked_option ||
//                                             "No response",
//                                             search
//                                           )}
//                                         </p>
//                                       </div>

//                                     </div>
//                                   )}
//                                 </div>
//                               );
//                             })}
//                         </div>
//                       )}
//                   </div>
//                 ))}
//             </div>

//           </div>
//         </div>


//       )}
//     </>
//   );
// }

import { useState, useRef, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentTextOutline } from "react-icons/io5";

export function KbSessionCell({ item }) {
  const [showModal, setShowModal] = useState(false);
  const [openSessions, setOpenSessions] = useState([]);
  const [openItems, setOpenItems] = useState({});
  const [search, setSearch] = useState("");

  const itemRefs = useRef([]);

  // const toggleSession = (sessionKey) => {
  //   setOpenSessions(prev =>
  //     prev.includes(sessionKey)
  //       ? prev.filter(id => id !== sessionKey)
  //       : [...prev, sessionKey]
  //   );
  // };
  const toggleSession = (sessionKey) => {
    if (openSessions.includes(sessionKey)) {
      // Closing session
      setOpenSessions(prev => prev.filter(id => id !== sessionKey));

      // Clear expanded questions for this session
      setOpenItems(prev => {
        const updated = { ...prev };
        delete updated[sessionKey];
        return updated;
      });
    } else {
      // Opening session
      setOpenSessions(prev => [...prev, sessionKey]);
    }
  };

  const toggleQuestion = (sessionKey, index) => {
    setOpenItems(prev => {
      const current = prev[sessionKey] || [];

      return {
        ...prev,
        [sessionKey]: current.includes(index)
          ? current.filter(i => i !== index)
          : [...current, index],
      };
    });
  };


  useEffect(() => {
    if (!showModal || !item?.length) return;

    if (!search.trim()) {
      const firstSessionId = item[0]?.id || 0;

      setOpenSessions([firstSessionId]);

      setOpenItems({
        [firstSessionId]: [0],
      });

      return;
    }

    const query = search.toLowerCase();

    const matchedSessions = [];
    const matchedQuestions = {};

    item.forEach((session, sessionIndex) => {
      const sessionKey = session.id || sessionIndex;

      const reversedHistory = [...(session.history || [])].reverse();

      const indexes = [];

      reversedHistory.forEach((h, index) => {
        const matched =
          h.question?.toLowerCase().includes(query) ||
          h.clicked_option?.toLowerCase().includes(query) ||
          h.resolution_text?.toLowerCase().includes(query) ||
          session.intent_name?.toLowerCase().includes(query) ||
          session.flow_name?.toLowerCase().includes(query);

        if (matched) {
          indexes.push(index);
        }
      });

      if (indexes.length) {
        matchedSessions.push(sessionKey);
        matchedQuestions[sessionKey] = indexes;
      }
    });

    setOpenSessions(matchedSessions);
    setOpenItems(matchedQuestions);
  }, [search, item, showModal]);


  useEffect(() => {
    if (!showModal || !item?.length) return;

    if (!search.trim()) {
      const firstSessionId = item[0]?.id || 0;

      setOpenSessions([firstSessionId]);

      setOpenItems({
        [firstSessionId]: [0],
      });

      return;
    }

    const query = search.toLowerCase();

    const matchedSessions = [];
    const matchedQuestions = {};

    item.forEach((session, sessionIndex) => {
      const sessionKey = session.id || sessionIndex;

      const reversedHistory = [...(session.history || [])].reverse();

      const indexes = [];

      reversedHistory.forEach((h, index) => {
        const matched =
          h.question?.toLowerCase().includes(query) ||
          h.clicked_option?.toLowerCase().includes(query) ||
          h.resolution_text?.toLowerCase().includes(query) ||
          session.intent_name?.toLowerCase().includes(query) ||
          session.flow_name?.toLowerCase().includes(query);

        if (matched) {
          indexes.push(index);
        }
      });

      if (indexes.length) {
        matchedSessions.push(sessionKey);
        matchedQuestions[sessionKey] = indexes;
      }
    });

    setOpenSessions(matchedSessions);
    setOpenItems(matchedQuestions);
  }, [search, item, showModal]);

  const escapeRegex = (str) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const highlightText = (text, query) => {
    if (!query) return text;

    const regex = new RegExp(`(${escapeRegex(query)})`, "gi");

    return String(text)
      .split(regex)
      .map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <span key={i} className="transcript-highlight">
            {part}
          </span>
        ) : (
          part
        )
      );
  };

  return (
    <>
      <IoDocumentTextOutline
        onClick={() => setShowModal(true)}
        style={{
          fontSize: "20px",
          cursor: "pointer",
          color: "#0782D5",
        }}
      />

      {showModal && (
        <div
          className="transcript-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="kb-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="kb-header">
              <div className="kb-headerLeft">
                <span className="kb-title">KB Session</span>
              </div>

              <div className="kb-headerRight">
                <input
                  type="text"
                  placeholder="Search logs..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="transcript-searchInput"
                />

                <button
                  className="transcript-closeBtn"
                  onClick={() => {
                    setShowModal(false);
                    setSearch("");
                  }}
                >
                  <IoClose size={18} />
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="kb-body">
              {item
                .filter((session) => session.history?.length > 0)
                .map((session, sessionIndex) => {
                  const sessionKey = session.id || sessionIndex;

                  return (
                    <div
                      key={sessionKey}
                      className="kb-card"
                    >
                      {/* Session Header */}
                      <div
                        className="kb-cardHeader kb-sessionAccordion"
                        onClick={() => toggleSession(sessionKey)}
                      >
                        <span className="kb-badge">
                          {highlightText(session.intent_name, search)}
                        </span>

                        <div className="kb-meta">
                          <span className="kb-flowName">
                            {highlightText(session.flow_name, search)}
                          </span>

                          <span className="kb-dot">•</span>

                          <span
                            className={`kb-statusTag ${session.status?.toLowerCase() === "completed"
                              ? "status-complete"
                              : "status-pending"
                              }`}
                          >
                            {session.status}
                          </span>
                        </div>

                        <span className="kb-sessionArrow">
                          {openSessions.includes(sessionKey) ? "▼" : "▶"}
                        </span>
                      </div>

                      {openSessions.includes(sessionKey) && (
                        <div className="kb-content">
                          {[...(session.history || [])]
                            .reverse()
                            .map((h, index) => {
                              const isOpen =
                                (openItems[sessionKey] || []).includes(index);;

                              return (
                                <div
                                  key={h.history_id || index}
                                  className={`kb-stepBlock ${isOpen ? "active" : ""
                                    }`}
                                >
                                  {/* Question */}
                                  <div
                                    className="kb-questionHeader"
                                    onClick={() =>
                                      toggleQuestion(sessionKey, index)
                                    }
                                  >
                                    <div className="kb-questionLeft">
                                      <span className="kb-label-badge q-badge">
                                        Q
                                      </span>

                                      <p className="kb-textQuestion">
                                        {highlightText(
                                          h.question,
                                          search
                                        )}
                                      </p>
                                    </div>

                                    <span className="kb-arrow">
                                      {isOpen ? "−" : "+"}
                                    </span>
                                  </div>

                                  {isOpen && (
                                    <div className="kb-answerContainer">
                                      {h.resolution_text && (
                                        <div className="kb-resolutionBox">
                                          <div className="kb-resolutionHeader">
                                            <span className="kb-resolutionIcon">
                                              🛠️
                                            </span>

                                            <span className="kb-resolutionText">
                                              {highlightText(
                                                h.resolution_text,
                                                search
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      <div className="kb-answerRow">
                                        <span className="kb-label-badge a-badge">
                                          A
                                        </span>

                                        <p
                                          className={`kb-textAnswer ${h.clicked_option?.toLowerCase() ===
                                            "yes"
                                            ? "ans-yes"
                                            : h.clicked_option?.toLowerCase() ===
                                              "no"
                                              ? "ans-no"
                                              : ""
                                            }`}
                                        >
                                          {highlightText(
                                            h.clicked_option ||
                                            "No response",
                                            search
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}